import { useState } from "react";

const ContactButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const socialButtons = [
    {
      id: "facebook",
      icon: "/logos/facebook.svg",
      link: "https://www.facebook.com/TaiSanTriTue",
    },
    {
      id: "zalo",
      icon: "/logos/zalo.svg",
      link: "https://zalo.me/0819009697",
    },
    {
      id: "telephone2",
      icon: "/logos/telephone2.svg",
      link: "tel:0819009697",
    },
    {
      id: "telephone1",
      icon: "/logos/telephone1.svg",
      link: "tel:0907729899",
    },
  ];

  return (
    <div className="fixed bottom-5 right-5 z-[100] isolate">
      {/* Nút chính */}
      <div className="relative w-12 h-12">
        {/* Hiệu ứng nảy (ping effect) */}
        <div
          className={`absolute inset-0 bg-white rounded-full transition-all ${
            isOpen ? "animate-none" : "animate-ping"
          }`}
        ></div>

        {/* Nút chính (chứa hình ảnh) */}
        <div
          className="relative flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-lg cursor-pointer z-10"
          onClick={() => setIsOpen(!isOpen)}
        >
          <img
            src={isOpen ? "/icons/x.svg" : "/icons/message.svg"}
            alt="Toggle"
            className={isOpen ? "size-3" : "size-6"}
          />
        </div>
      </div>

      {/* Danh sách nút mạng xã hội */}
      <div
        className={`relative z-[101] ${isOpen ? "" : "pointer-events-none"}`}
      >
        {socialButtons.map(({ id, icon, link }, index) => (
          <div
            key={id}
            className="absolute right-0 flex items-center justify-center"
            style={{
              transform: isOpen
                ? `translateY(-${(index + 2) * 64 - 16}px)`
                : "translateY(-64px)",
              opacity: isOpen ? 1 : 0,
              transition: "transform 0.4s ease, opacity 0.4s ease",
            }}
          >
            {/* Nút mạng xã hội */}
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="relative z-[102] flex size-12 items-center justify-center rounded-full bg-white text-white shadow-lg hover:animate-bounce"
            >
              <img src={icon} alt={id} className="size-12" />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactButton;
